















import { apiCommodityCommodityStoreDetail } from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { ImagePreview } from 'vant'
import { requiredDeep, Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '商家资质信息',
        }))
      }

      query = useQuery<{
        // 商家 ID
        id: string
      }>()

      apiData = useApi(() =>
        apiCommodityCommodityStoreDetail({
          storeId: this.query.id,
        }).then(requiredDeep),
      )

      // 资质数据
      certData = computed(() => this.apiData.data.store.storeQualification)

      previewImage = (index: number) => {
        ImagePreview({
          images: this.certData.value,
          startPosition: index,
        })
      }
    },
)
